module.exports = __webpack_public_path__ + "img/animation_rain.e61fd1c9.gif";